import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guard/auth.guard';
import { ageyMobileRoutes, ageyRoutes } from './routes/agey.routes';
import { customHiringCentreAdminRoutes, customHiringCentreMobileRoutes } from './routes/custom-hiring-center.routes';
import { eepMobileRoutes, entrepreneurEnterpriseProfileRoutes } from './routes/entrepreneur-enterprise-profile.routes';
import { ifcClustersMobileRoutes, ifcClustersRoutes } from './routes/ifc-clusters.routes';
import { incubatorMobileRoutes, incubatorRoutes } from './routes/incubator.routes';
import { masterRoutes } from './routes/master.routes';
import { pmfmeMobileRoutes, pmfmeRoutes } from './routes/pmfme.routes';
import { producerEnterpriseRoutes } from './routes/producer-enterprise.routes';
import { producerGroupMobileRoutes, producerGroupRoutes } from './routes/producer-group.routes';
import { reportsRoutes } from './routes/reports.routes';
import { userMappingRoutes } from './routes/user-mapping.routes';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    // Dashboard
    {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [authGuard]
    },
    // Livelihood (temporarily disabled)
    {
        path: 'livelihood',
        loadChildren: () => import('./producer-group/livelihood/livelihood.module').then((m) => m.LivelihoodModule),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/filter',
        loadComponent: () => import('./mobile/shared/filter/filter.component').then((m) => m.FilterComponent),
        canActivate: [authGuard]
    },
    ...producerGroupRoutes,
    ...producerEnterpriseRoutes,
    ...entrepreneurEnterpriseProfileRoutes,
    ...ifcClustersRoutes,
    ...incubatorRoutes,
    ...masterRoutes,
    ...reportsRoutes,
    ...ageyRoutes,
    ...customHiringCentreAdminRoutes,
    ...userMappingRoutes,
    ...pmfmeRoutes,
    // Mobile Screens
    ...producerGroupMobileRoutes,
    ...eepMobileRoutes,
    ...ifcClustersMobileRoutes,
    ...ageyMobileRoutes,
    ...customHiringCentreMobileRoutes,
    ...pmfmeMobileRoutes,
    ...incubatorMobileRoutes
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
